import React from 'react';
import {
  ButtonToolbar,
  Checkbox,
  DropdownButton,
  MenuItem,
} from 'react-bootstrap';

const CategorySelect = ({
  category,
  onSelectCategory,
  selectedCategories,
  selectedFilters,
  onSelectFilter,
}) => {
  const { title, icon, filters } = category;

  const handleDropdownSelect = (key) => onSelectFilter(category.key, key);
  return (
    <div className="flex category-select flex-wrap m-l-16 m-b-12">
      {icon}
      <ButtonToolbar>
        <DropdownButton
          id={`category-select-${category.key}`}
          bsStyle="info"
          title={title}
          className="btn-block btn-clear bg-transparent"
          style={{ padding: '6px 16px', minWidth: '80px', fontSize: '16px' }}
          onSelect={handleDropdownSelect}
        >
          {filters.map(
            ({ key, title, disabled, hidden }) =>
              !hidden && (
                <MenuItem
                  key={key}
                  active={selectedFilters[key]}
                  disabled={disabled}
                  eventKey={key}
                >
                  {title}
                </MenuItem>
              )
          )}
          <MenuItem divider />
        </DropdownButton>
      </ButtonToolbar>
      <Checkbox
        className="m-0"
        checked={selectedCategories[category.key]}
        onChange={() => onSelectCategory(category.key)}
      >
        <span className="checkmark"></span>
      </Checkbox>
    </div>
  );
};

export default CategorySelect;
